import { AlmeUIResponse} from '@alme/ui-web/types/response';
import { Store } from "redux";

import {AlmeResponseV5} from '@alme/types/response/AlmeResponse';
import {ResponseAction} from '@alme/types/response/ResponseAction';
import ResponseActionHandler from '@alme/ui-web/types/response-action-handler';
import { AlmeState } from '@alme/ui-web/wireup/AlmeState';
import { AlightCustomSettingsType } from '../../settings/alight-custom-settings';
//@ts-ignore

export default class WebMessagingResponseHandler extends ResponseActionHandler{
    _settings: AlightCustomSettingsType;
    constructor(settings: AlightCustomSettingsType) {
        super(["AppeventRequest", "ConverseRequest", "RequestUnitRequest", "GetNotificationRequest"], ["LaunchWebMessenger"], settings);
        this._settings = settings;
    }

    initialize(store: Store<AlmeState>): void {
        this._store = store;
    }

    processResponse(response: AlmeResponseV5): AlmeResponseV5 {
        if(window?._altGCWM?.open)
            {
                window._altGCWM.open();
            }
        return response;
    }
}


// WEBPACK FOOTER //
// ./modules/response-handler-webmessaging/response-handler-webmessaging.ts